var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import WSRCalendar from 'wix-style-react/dist/es/src/Calendar';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { st, classes } from './DatePicker.st.css';
import { DATA_HOOKS } from './constants';
/** The DatePicker allows a user to select a specific date. */
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, value = _a.value, onChange = _a.onChange, onMonthChange = _a.onMonthChange, locale = _a.locale, excludePastDates = _a.excludePastDates, filterDate = _a.filterDate, firstDayOfWeek = _a.firstDayOfWeek, showMonthDropdown = _a.showMonthDropdown, showYearDropdown = _a.showYearDropdown, dateIndication = _a.dateIndication, today = _a.today, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], leftArrowAriaLabel = _a.leftArrowAriaLabel, leftArrowAriaLabelledBy = _a.leftArrowAriaLabelledBy, rightArrowAriaLabel = _a.rightArrowAriaLabel, rightArrowAriaLabelledBy = _a.rightArrowAriaLabelledBy, monthDropdownAriaLabel = _a.monthDropdownAriaLabel, monthDropdownAriaLabelledBy = _a.monthDropdownAriaLabelledBy, yearDropdownAriaLabel = _a.yearDropdownAriaLabel, yearDropdownAriaLabelledBy = _a.yearDropdownAriaLabelledBy, removeOuterPadding = _a.removeOuterPadding;
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var rtl = _a.rtl;
            return (React.createElement("div", { className: st(classes.root, className), "data-hook": _this.props['data-hook'], "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, role: "region" },
                React.createElement(WSRCalendar, { className: st(classes.calendar, { removeOuterPadding: removeOuterPadding }), dataHook: DATA_HOOKS.WSR_CALENDAR, value: value, onChange: onChange, onMonthChange: onMonthChange, locale: locale, excludePastDates: excludePastDates, filterDate: filterDate, firstDayOfWeek: firstDayOfWeek, showMonthDropdown: showMonthDropdown, showYearDropdown: showYearDropdown, rtl: rtl, selectionMode: "day", numOfMonths: 1, autoFocus: false, dateIndication: dateIndication, leftArrowAriaLabel: leftArrowAriaLabel, leftArrowAriaLabelledBy: leftArrowAriaLabelledBy, rightArrowAriaLabel: rightArrowAriaLabel, rightArrowAriaLabelledBy: rightArrowAriaLabelledBy, monthDropdownAriaLabel: monthDropdownAriaLabel, monthDropdownAriaLabelledBy: monthDropdownAriaLabelledBy, yearDropdownAriaLabel: yearDropdownAriaLabel, yearDropdownAriaLabelledBy: yearDropdownAriaLabelledBy, today: today })));
        }));
    };
    DatePicker.displayName = 'DatePicker';
    DatePicker.defaultProps = {
        locale: 'en',
        excludePastDates: false,
        filterDate: function () { return true; },
        showMonthDropdown: false,
        showYearDropdown: false,
        dateIndication: function (_a) {
            var Date = _a.date, boolean = _a.isSelected;
            return null;
        },
    };
    return DatePicker;
}(React.Component));
export { DatePicker };
//# sourceMappingURL=DatePicker.js.map